import { Component, Input, Signal } from '@angular/core';
import { PrimeNgModule } from 'src/app/shared/prime-ng/prime-ng.module';
import { EtapasProyectoInterfaces, EtapasProyectoTramite } from 'src/app/users/tramites/components/interfaces/formulario.interfaces';

@Component({
  selector: 'app-etapa-proyecto-item',
  standalone: true,
  imports: [PrimeNgModule],
  templateUrl: './etapa-proyecto-item.component.html',
  styleUrl: './etapa-proyecto-item.component.scss'
})
export class EtapaProyectoItemComponent {
  @Input() etapaProyectoTramite!: EtapasProyectoInterfaces[];
}
